import { Getters as G } from 'vuex-smart-module'
import { State } from './State'


export abstract class Getters<T, TT, S extends State<T, TT> = State<T, TT>> extends G<S> {
  public get pagination() {
    const { filters, listMeta } = this.state

    let page = filters.page as number
    page = Number.isNaN(+page) ? 1 : +page

    return {
      page,
      per_page: filters.per_page as number,
      count: listMeta?.count as number,
    }
  }
}
